import React, { useEffect, useState } from "react";
import Cookies from "universal-cookie";

// components
import Card from "./components/Card";
import CommonHeader from "../../../../common/components/CommonHeader";
import APIScreen from "../../../../common/components/APIScreen";
import APIVarification from "../../../../common/components/APIScreen/elements/APIVarification";
import APICreateForm from "../../../../common/components/APIScreen/elements/APICreateForm";
import Feedback from "../Help/components/Feedback";
import CardSkeleton from "./components/CardSkeleton";
import NotFound from "../../../../common/NotFound";
import LicenseVarification from "../../../../common/components/LicenseScreen/elements/LicenseVarification";
import LicenseScreen from "../../../../common/components/LicenseScreen";

const noDataIcon = `${EASYCOMMERCE.assets}admin/img/nofound/no-data.png`;

const Addons = () => {
    const [user, setUser] = useState(null);
    const [posts, setPosts] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [showAPIModal, setShowAPIModal] = useState(false);
    const [currentAPIModalTab, setCurrentAPIModalTab] = useState("");
    const [isConnected, setIsConnected] = useState(false);
    const [ClickedAddon, setClickedAddon] = useState(null);

    const handleModalClose = () => {
        setShowAPIModal(false);
        setCurrentAPIModalTab("");
    };

    useEffect(() => {
        fetch(`${EASYCOMMERCE.rest_base}/addons`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "X-WP-Nonce": EASYCOMMERCE.nonce,
            },
        })
            .then((res) => res.json())
            .then((data) => {
                setIsLoading(false);
                if (data.success && data.data?.addons) {
                    const addonsArray = Object.values(data.data.addons);
                    setPosts(addonsArray);
                }
            });
    }, []);

    useEffect(() => {
        const cookies = new Cookies(null, { path: "/" });
        const easyUser = cookies.get("easy-user");

        // if (easyUser && easyUser.id) {
            setIsConnected(true);
        // }
    }, [user]);

    return (
        <>
            <CommonHeader
                parentSlug="easycommerce"
                parentLavel="EasyCommerce"
                breadcumpSlug="Addons"
            >
                <Feedback />
                |
                <div>
                    <a href="https://support.easycommerce.dev" target="_blank" className="flex items-center cursor-pointer p-2 font-inter font-medium text-sm leading-5 text-ec-primary hover:text-ec-primary focus:shadow-none focus:text-ec-primary">Contact Support</a>
                </div>
            </CommonHeader>

            <div className="mt-[30px] mx-[30px] bg-white max-w-full py-[50px] px-[100px] mb-10 rounded-lg">
                {!isLoading ? (
                    <>
                        {posts.length > 0 ? (
                            <>
                                <div className="easycommerce-addons-heading text-center">
                                    <h2 className="text-center text-[32px] font-inter font-normal text-ec-title leading-[48px] mb-3">
                                        EasyCommerce Addons
                                    </h2>
                                    <p className="text-ec-body text-base font-inter font-normal leading-[26px] mb-12">
                                        Use EasyCommerce addons to extend and customize the functionality of your online store.
                                    </p>
                                </div>

                                <div className="grid grid-cols-4 gap-[30px]">
                                    {posts.length > 0 &&
                                        posts.map((post, index) => (
                                            <Card
                                                key={index}
                                                post={post}
                                                isConnected={isConnected}
                                                showModal={() =>
                                                    setShowAPIModal(true)
                                                }
                                                setShowAPIModal={setShowAPIModal}
                                                setCurrentAPIModalTab={setCurrentAPIModalTab}
                                                setClickedAddon={setClickedAddon}
                                            />
                                        ))}
                                </div>
                            </>
                        ) : (
                            <NotFound
                                ImageUrl={noDataIcon}
                                title="No Addons Found"
                            />
                        )}
                    </>
                ) : (
                    <CardSkeleton />
                )}
            </div>

            {showAPIModal && (
                <>
                    {currentAPIModalTab === "" ? (
                        <APIScreen
                            onClose={handleModalClose}
                            switchVariationModalTab={() =>
                                setCurrentAPIModalTab("apiVarification")
                            }
                            switchCreateModalTab={() =>
                                setCurrentAPIModalTab("apiCreate")
                            }
                        />
                    ) : currentAPIModalTab === "apiVarification" ? (
                        <APIVarification
                            onClose={handleModalClose}
                            switchModalTab={() =>
                                setCurrentAPIModalTab("apiCreate")
                            }
                            setUserAfterVarification={(userData) => {
                                setUser(userData);
                                window.location.reload();
                            }}
                        />
                    ) : currentAPIModalTab === "apiCreate" ? (
                        <APICreateForm
                            onClose={handleModalClose}
                            switchModalTab={() =>
                                setCurrentAPIModalTab("apiVarification")
                            }
                        />
                    ) : currentAPIModalTab === "license" ? ( 
                        <LicenseVarification
                            onClose={handleModalClose}
                            addon={ClickedAddon}
                            switchModalTab={() => setCurrentAPIModalTab("licenseVerification")}
                        />
                    ) : currentAPIModalTab === "licenseVerification" ? (
                        <LicenseScreen
                            addon={ClickedAddon}
                            onClose={handleModalClose}
                            switchVariationModalTab={() =>
                                setCurrentAPIModalTab("license")
                            }
                        />
                    ) : null}
                </>
            )}
        </>
    );
};

export default Addons;
